"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftAresGlobalParametersDeferred = void 0;
var DeferredAction_1 = require("./DeferredAction");
var ShiftAresGlobalParameters_1 = require("../inputs/ShiftAresGlobalParameters");
var AresHandler_1 = require("../ares/AresHandler");
var ShiftAresGlobalParametersDeferred = (function () {
    function ShiftAresGlobalParametersDeferred(player) {
        this.player = player;
        this.priority = DeferredAction_1.Priority.DEFAULT;
    }
    ShiftAresGlobalParametersDeferred.prototype.execute = function () {
        var _this = this;
        var pi = undefined;
        AresHandler_1.AresHandler.ifAres(this.player.game, function (aresData) {
            pi = new ShiftAresGlobalParameters_1.ShiftAresGlobalParameters(_this.player, aresData, function (response) {
                var hazardData = aresData.hazardData;
                if (hazardData.erosionOceanCount.available) {
                    hazardData.erosionOceanCount.threshold += response.lowOceanDelta;
                }
                if (hazardData.removeDustStormsOceanCount.available) {
                    hazardData.removeDustStormsOceanCount.threshold += response.highOceanDelta;
                }
                if (hazardData.severeErosionTemperature.available) {
                    hazardData.severeErosionTemperature.threshold += (response.temperatureDelta * 2);
                }
                if (hazardData.severeDustStormOxygen.available) {
                    hazardData.severeDustStormOxygen.threshold += response.oxygenDelta;
                }
                if (response.temperatureDelta !== 0) {
                    AresHandler_1.AresHandler.onTemperatureChange(_this.player.game, aresData);
                }
                if (response.oxygenDelta !== 0) {
                    AresHandler_1.AresHandler.onOxygenChange(_this.player.game, aresData);
                }
                if (response.lowOceanDelta !== 0 || response.highOceanDelta !== 0) {
                    AresHandler_1.AresHandler.onOceanPlaced(aresData, _this.player);
                }
                return undefined;
            });
        });
        if (pi === undefined) {
            throw new Error('Should not reach.');
        }
        return pi;
    };
    ;
    return ShiftAresGlobalParametersDeferred;
}());
exports.ShiftAresGlobalParametersDeferred = ShiftAresGlobalParametersDeferred;
//# sourceMappingURL=ShiftAresGlobalParametersDeferred.js.map